export const CREDIT_CARD = 'creditcard';

export const PAYPAL = 'paypal';

export const ECHECK = 'echeck';

export const AMAZON = 'amazonpay';

export const CREDIT_CARD_TYPE_VISA = 'VI';

export const CREDIT_CARD_TYPE_VISA_2 = 'visa';

export const CREDIT_CARD_TYPE_MASTER_CARD = 'mastercard';

export const CREDIT_CARD_TYPE_AMEX = 'amex';

export const CREDIT_CARD_TYPE_DISCOVER = 'discover';
